import React, { FC, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import Loading from '../../../components/common/Loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ExtraOrderModal from '../../../components/common/ExtraOrderModal'
import { Link, useParams } from 'react-router-dom'
import { setPath } from '../../../../utils/url'
import { LangValue } from '../../../../states/types/common'
import { URL } from '../../../constants/url'

const OPTION = [
  {
    label: "ai_work_assessment",
    name: "AI業務分析",
  },
  {
    label: "organizational_analysis",
    name: "組織分析",
  },
  {
    label: "risk_assessment",
    name: "リスクアセスメント",
  },
  {
    label: "self_management",
    name: "セルフマネジメント",
  },
]

const Index: FC = () => {
  const { language } = useParams<{ language: LangValue }>()

  const {
    commonPart,
    login,
  } = useSelector<RootState, RootState>((state: RootState) => (state))

  const [displayExtraOrder, setDisplayExtraOrder] = useState<boolean>(false)

  const buildOption = (targetLabel: string, contract: boolean) => {
    const target = OPTION.find((v) => v.label === targetLabel)
    if (!target || !contract) return (<></>)
    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <div>
            {target.name}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {
        commonPart.isLoading ? (
          <Loading />
        ) : (
          <section className="setting_page">
            <Helmet>
              <title>{`Qasee - 設定 - ${login.role_name === "管理者" ? "管理者" : "共通"}設定 - 契約情報`}</title>
            </Helmet>
            <section className="breadcrumb">
              設定
              &nbsp;&gt;&nbsp;
              <Link
                to={setPath(URL.SETTING_COMMON.path, language)}
              >
                {`${login.role_name === "管理者" ? "管理者" : "共通"}設定`}
              </Link>
              &nbsp;&gt;&nbsp;
              契約情報
              &nbsp;
            </section>
            <section className="page_header">
              <h1>
                契約情報
              </h1>
              <div className="tools">
                <div className="button_area">
                  <button
                    type="button"
                    className="change_contract"
                    onClick={() => setDisplayExtraOrder(true)}
                  >
                    <FontAwesomeIcon icon={['far', 'lightbulb']} />
                    契約情報の変更
                  </button>
                </div>
              </div>
            </section>
            <section className="page_description">
              <p>
                契約情報の確認やユーザー上限の追加、オプション機能の追加ができます。
              </p>
            </section>
            <section className="page_contents content-area">
              <div
                style={{
                  display: "flex",
                  flexFlow: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                    }}
                  >
                    現在のユーザー上限数
                  </div>
                  <div
                    style={{
                      width: "calc(100% - 200px)",
                      display: "flex",
                      alignItems: "baseline",
                      gap: "2px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "20px",
                      }}
                    >
                      {login.limit_member_number?.toLocaleString()}
                    </div>
                    <div>
                      名
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    padding: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                    }}
                  >
                    現在の契約済みオプション
                  </div>
                  <div
                    style={{
                      width: "calc(100% - 200px)",
                      display: "flex",
                      flexFlow: "column",
                      gap: "4px",
                      fontSize: "14px",
                    }}
                  >
                    {buildOption("organizational_analysis", login.function_enabled_state?.organizational_analysis || false)}
                    {buildOption("ai_work_assessment", login.function_enabled_state?.ai_work_assessment || false)}
                    {buildOption("risk_assessment", login.function_enabled_state?.risk_assessment || false)}
                    {buildOption("self_management", login.function_enabled_state?.self_management || false)}
                    {
                      (
                        !login.function_enabled_state?.organizational_analysis
                        && !login.function_enabled_state?.ai_work_assessment
                        && !login.function_enabled_state?.risk_assessment
                        && !login.function_enabled_state?.self_management
                      ) && (
                        <>
                          オプション契約なし
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "24px",
                }}
              >
                <button
                  type="button"
                  className="button change_contract"
                  onClick={() => setDisplayExtraOrder(true)}
                >
                  <FontAwesomeIcon icon={['far', 'lightbulb']} />
                  契約情報の変更
                </button>
              </div>
            </section>
          </section>
        )
      }
      <ExtraOrderModal
        display={displayExtraOrder}
        closeCallback={() => setDisplayExtraOrder(false)}
      />
    </>
  )
}

export default Index
